import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=1712c35b&"
import script from "./Layout1.vue?vue&type=script&lang=js&"
export * from "./Layout1.vue?vue&type=script&lang=js&"
import style0 from "./Layout1.vue?vue&type=style&index=0&id=1712c35b&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1712c35b')) {
      api.createRecord('1712c35b', component.options)
    } else {
      api.reload('1712c35b', component.options)
    }
    module.hot.accept("./Layout1.vue?vue&type=template&id=1712c35b&", function () {
      api.rerender('1712c35b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Layout1.vue"
export default component.exports